import { render, staticRenderFns } from "./BrImagePreviewModal.vue?vue&type=template&id=1efd4b56&scoped=true&"
import script from "./BrImagePreviewModal.vue?vue&type=script&lang=js&"
export * from "./BrImagePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./BrImagePreviewModal.vue?vue&type=style&index=0&id=1efd4b56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd4b56",
  null
  
)

export default component.exports